import HOMEPAGE_SEARCH_INDEX_CONFIG from '@/app/config/homepage'
import { ICategoryWithSubcategoriesHit } from '@/types/search'
import { getSearchClient } from '../../search/lib/search-client'
import { HeaderMenuItems } from '../context/HeaderMenuItemsContext'

export async function getHeaderMenuItems() {
  const isServer = typeof window === 'undefined'

  // Since the search query needs to be made server side, return empty array if on client-side
  if (!isServer) {
    return []
  }

  const isExternalSearchEnabled = HOMEPAGE_SEARCH_INDEX_CONFIG.enabled
  // This env var is only available in the ssr env
  const frontendSearchApiKey = process.env.NEXT_SEARCH_INDEX_FRONTEND_API_KEY

  if (!isExternalSearchEnabled || !frontendSearchApiKey) {
    return []
  }

  const searchClient = getSearchClient(frontendSearchApiKey, {
    collectionSpecificSearchParameters: {
      categories: {
        query_by: '*',
        sort_by: 'display_order:asc,name:asc',
        collection: 'categories',
        limit: 10,
        q: '*',
        filter_by:
          'is_active:=true&&$subcategories(is_active:=true&&$subcategories_courses($courses(published:=true)))',
        exclude_fields: '$subcategories($subcategories_courses($courses(*)))',
      },
      subcategories: {
        query_by: '*',
        sort_by: 'display_order:asc,name:asc',
        collection: 'subcategories',
        limit: 10,
        q: '*',
        filter_by:
          'is_active:=true&&$subcategories_courses($courses(published:=true))',
        exclude_fields: '$subcategories($subcategories_courses($courses(*)))',
      },
    },
  })

  const searchRequests = [
    { indexName: 'categories', params: { query: '' } },
    { indexName: 'subcategories', params: { query: '' } },
  ]

  const {
    results: [
      { hits: categoryHits = [] } = {},
      { hits: subCategoryHits = [] } = {},
    ] = [],
  } = await searchClient.search<ICategoryWithSubcategoriesHit>(searchRequests)

  const headerMenuItems: HeaderMenuItems = [
    {
      id: 'categories',
      items: categoryHits.map(
        ({ name, id, slug, display_order: displayOrder }) => {
          return { name, id, slug, displayOrder }
        }
      ),
    },
    {
      id: 'subcategories',
      items: subCategoryHits.map(
        ({ name, id, slug, display_order: displayOrder }) => {
          return { name, id, slug, displayOrder }
        }
      ),
    },
  ]

  return headerMenuItems
}
